import { isWithinInterval, parseISO, addDays, startOfToday } from "date-fns";

export const withinWeek = (isoDate) =>
  isWithinInterval(parseISO(isoDate), {
    start: startOfToday(),
    end: addDays(startOfToday(), 6),
  });
